import { render, staticRenderFns } from "./PosterDeal.vue?vue&type=template&id=7463b5ed&scoped=true&"
import script from "./PosterDeal.vue?vue&type=script&lang=js&"
export * from "./PosterDeal.vue?vue&type=script&lang=js&"
import style0 from "./PosterDeal.vue?vue&type=style&index=0&id=7463b5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463b5ed",
  null
  
)

export default component.exports